import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TabBar from '@lib/components/TabBar/TabBar';
import { TabBarItem as TabBarItemType } from '@lib/components/TabBar/constants';
import getTableTabs from '../utils/getTableTabs';
import styles from './SectorMenuBar.module.scss';

interface Props {
  active: string;
  id: string;
  isUsersManagementLocked: boolean;
  sitesCount: number;
  usersCount: number;
}

export default function SectorMenuBar({
  active,
  id,
  isUsersManagementLocked,
  sitesCount,
  usersCount,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const tabs = getTableTabs({
    id,
    t,
    sitesCount,
    usersCount,
    isUsersManagementLocked,
  });
  const onActiveTabChange = ({ value }: TabBarItemType) => {
    navigate(value);
  };
  return (
    <div className={styles.menuRoot}>
      <TabBar
        items={tabs}
        active={active}
        onActiveChange={onActiveTabChange}
        useSidePaddings
      />
    </div>
  );
}
